// src/services/employeeService.jsx
import axiosInstance from './axiosConfig';

const employeeService = {
  getAll: async (page = 1, limit = 10) => {
    const response = await axiosInstance.get(`/employees?page=${page}&limit=${limit}`);
    return response.data.data ?? response.data;
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/employees/${id}`);
    return response.data.data ?? response.data;
  },

  getDepartments: async () => {
    const response = await axiosInstance.get('/departments');
    return response.data.data ?? response.data;
  },

  getDesignations: async () => {
    const response = await axiosInstance.get('/designations');
    return response.data.data ?? response.data;
  },

  create: async (payload) => {
    try {
      console.log('📤 SENDING PAYLOAD TO BACKEND:');
      console.log(JSON.stringify(payload, null, 2));
      
      const response = await axiosInstance.post('/employees/create', payload);
      
      console.log('✅ SUCCESS RESPONSE:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ CREATE EMPLOYEE ERROR OCCURRED');
      
      // 🔍 DETAILED ERROR LOGGING
      if (error.response) {
        console.error('=====================================');
        console.error('📊 HTTP Status Code:', error.response.status);
        console.error('📋 Full Response Data:');
        console.error(JSON.stringify(error.response.data, null, 2));
        console.error('=====================================');
        
        // Check for different error response structures
        if (error.response.data?.message) {
          console.error('💬 Message:', error.response.data.message);
        }
        if (error.response.data?.error) {
          console.error('⚠️ Error:', error.response.data.error);
        }
        if (error.response.data?.errors) {
          console.error('⚠️ Errors Array:');
          console.error(JSON.stringify(error.response.data.errors, null, 2));
        }
        if (error.response.data?.details) {
          console.error('📝 Details:', error.response.data.details);
        }
        
        // Show all keys in response for debugging
        console.error('📌 All response keys:', Object.keys(error.response.data));
        
      } else if (error.request) {
        console.error('❌ No Response from server');
        console.error('Request:', error.request);
      } else {
        console.error('❌ Error Message:', error.message);
      }
      
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/employees/edit/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('❌ UPDATE EMPLOYEE ERROR:', error.response?.data || error.message);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/employees/delete/${id}`);
      return response.data;
    } catch (error) {
      console.error('❌ DELETE EMPLOYEE ERROR:', error.response?.data || error.message);
      throw error;
    }
  },
};

export default employeeService;